import * as ActionTypes from '../ActionTypes';

const initialState = {
    visitorLoading: false,
    visitors_data: [],
    addVisitorSuccess: false,
    visitor_reasons: [],
    error: null,
    visitors_dashboard_data: [],

    visitorReasonsLoading: false,
    visitorReasonsData: [],
    visitorRegionsLoading: false,
    visitorRegionsData: [],

    visitorsSettingLoading: false,
    visitorsExtraSettingData: [],

    vmOrgTypeLoading: false,
    vmOrgTypeData: [],
    vmMultipleOrgLoading: false,
    vmMultipleOrgData: [],

    vmPreRegistrationLoading: false,
    vmPreRegistrationData: [],
};

export const VisitorsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.VISITORS_GET_REQUEST:
            return {
                ...state,
                visitorLoading: true,
                visitors_data: [],
                error: false,
            };
        case ActionTypes.VISITORS_GET_SUCCESS:
            return {
                ...state,
                visitors_data: action.payload?.data?.data,
                visitorLoading: false,
                error: false,
            };
        case ActionTypes.VISITORS_GET_ERROR:
            return {
                ...state,
                visitorLoading: false,
                error: true,
            };
        case ActionTypes.VISITORS_DATA_GET_REQUEST:
            return {
                ...state,
                visitorLoading: true,
                // visitors_dashboard_data: [],
                error: false,
            };
        case ActionTypes.VISITORS_DATA_GET_SUCCESS:
            return {
                ...state,
                visitors_dashboard_data: action.payload?.data?.data,
                visitorLoading: false,
                error: false,
            };
        case ActionTypes.VISITORS_DATA_GET_ERROR:
            return {
                ...state,
                visitorLoading: false,
                error: true,
            };

        case ActionTypes.ADD_VISITORS_REQUEST:
            return {
                ...state,
                visitorLoading: true,
                error: false,
            };
        case ActionTypes.ADD_VISITORS_SUCCESS:
            return {
                ...state,
                visitorLoading: false,
                visitors_data: action.payload?.data?.data,
                error: false,
            };
        case ActionTypes.ADD_VISITORS_ERROR:
            return {
                ...state,
                visitorLoading: false,
                error: true,
            };

        case ActionTypes.GET_VISITORS_REASON_REQUEST:
            return {
                ...state,
                visitorLoading: true,
                error: false,
            };
        case ActionTypes.GET_VISITORS_REASON_SUCCESS:
            return {
                ...state,
                visitorLoading: false,
                visitor_reasons: action.payload?.data?.data || [],
                error: false,
            };
        case ActionTypes.GET_VISITORS_REASON_ERROR:
            return {
                ...state,
                visitorLoading: false,
                error: true,
            };
        case ActionTypes.UPDATE_VISITORS_REQUEST:
            return {
                ...state,
                visitorLoading: true,
                error: false,
            };
        case ActionTypes.UPDATE_VISITORS_SUCCESS:
            return {
                ...state,
                visitorLoading: false,
                visitors_data: action.payload?.data?.data,
                error: false,
            };
        case ActionTypes.UPDATE_VISITORS_ERROR:
            return {
                ...state,
                visitorLoading: false,
                error: true,
            };
        case ActionTypes.UPDATE_BULK_VISITORS_REQUEST:
            return {
                ...state,
                visitorLoading: true,
                error: false,
            };
        case ActionTypes.UPDATE_BULK_VISITORS_SUCCESS:
            return {
                ...state,
                visitorLoading: false,
                visitors_data: action.payload?.data?.data,
                error: false,
            };
        case ActionTypes.UPDATE_BULK_VISITORS_ERROR:
            return {
                ...state,
                visitorLoading: false,
                error: true,
            };  
        case ActionTypes.VISITOR_MANAGEMENT_REASON_GET_REQUEST:
            return {
                ...state,
                visitorReasonsLoading: true,
                visitorReasonsData: [],
                error: null,
            }
        case ActionTypes.VISITOR_MANAGEMENT_REASON_ADD_REQUEST:
        case ActionTypes.VISITOR_MANAGEMENT_REASON_UPDATE_REQUEST:
        case ActionTypes.VISITOR_MANAGEMENT_REASON_DELETE_REQUEST:
            return {
                ...state,
                visitorReasonsLoading: true,
                error: null,
            };

        case ActionTypes.VISITOR_MANAGEMENT_REASON_GET_SUCCESS:
        case ActionTypes.VISITOR_MANAGEMENT_REASON_ADD_SUCCESS:
        case ActionTypes.VISITOR_MANAGEMENT_REASON_UPDATE_SUCCESS:
        case ActionTypes.VISITOR_MANAGEMENT_REASON_DELETE_SUCCESS:
            return {
                ...state,
                visitorReasonsLoading: false,
                visitorReasonsData: action.payload?.data?.data,
                error: null,
            };

        case ActionTypes.VISITOR_MANAGEMENT_REASON_GET_ERROR:
        case ActionTypes.VISITOR_MANAGEMENT_REASON_ADD_ERROR:
        case ActionTypes.VISITOR_MANAGEMENT_REASON_UPDATE_ERROR:
        case ActionTypes.VISITOR_MANAGEMENT_REASON_DELETE_ERROR:
            return {
                ...state,
                visitorReasonsLoading: false,
                error: true,
            };

        // Visitor Management Regions
        case ActionTypes.VISITOR_MANAGEMENT_REGION_GET_REQUEST:
            return {
                 ...state,
                visitorRegionsLoading: true,
                visitorRegionsData: [],
                error: null,
            }
        case ActionTypes.VISITOR_MANAGEMENT_REGION_ADD_REQUEST:
        case ActionTypes.VISITOR_MANAGEMENT_REGION_UPDATE_REQUEST:
        case ActionTypes.VISITOR_MANAGEMENT_REGION_DELETE_REQUEST:
            return {
                ...state,
                visitorRegionsLoading: true,
                error: null,
            };

        case ActionTypes.VISITOR_MANAGEMENT_REGION_GET_SUCCESS:
        case ActionTypes.VISITOR_MANAGEMENT_REGION_ADD_SUCCESS:
        case ActionTypes.VISITOR_MANAGEMENT_REGION_UPDATE_SUCCESS:
        case ActionTypes.VISITOR_MANAGEMENT_REGION_DELETE_SUCCESS:
            return {
                ...state,
                visitorRegionsLoading: false,
                visitorRegionsData: action.payload?.data?.data,
                error: null,
            };

        case ActionTypes.VISITOR_MANAGEMENT_REGION_GET_ERROR:
        case ActionTypes.VISITOR_MANAGEMENT_REGION_ADD_ERROR:
        case ActionTypes.VISITOR_MANAGEMENT_REGION_UPDATE_ERROR:
        case ActionTypes.VISITOR_MANAGEMENT_REGION_DELETE_ERROR:
            return {
                ...state,
                visitorRegionsLoading: false,
                error:true,
            };   
        case ActionTypes.VM_EXTRA_SETTING_GET_REQUEST :
        case ActionTypes.VM_EXTRA_SETTING_UPDATE_REQUEST :
            return {
                ...state,
                visitorsSettingLoading: true,
                error: null,
            };

        case ActionTypes.VM_EXTRA_SETTING_GET_SUCCESS :
        case ActionTypes.VM_EXTRA_SETTING_UPDATE_SUCCESS :
            return {
                ...state,
                visitorsSettingLoading: false,
                visitorsExtraSettingData: action.payload?.data?.data,
                error: null,
            };

        case ActionTypes.VM_EXTRA_SETTING_GET_ERROR :
        case ActionTypes.VM_EXTRA_SETTING_UPDATE_ERROR :
            return {
                ...state,
                visitorsSettingLoading: false,
                error:true,
            }; 
        
        // VM Org Type
        case ActionTypes.VM_ORG_TYPE_GET_REQUEST:
        case ActionTypes.VM_ORG_TYPE_UPDATE_REQUEST:
            return {
                ...state,
                vmOrgTypeLoading: true,
                error: null,
            };
        case ActionTypes.VM_ORG_TYPE_GET_SUCCESS:
        case ActionTypes.VM_ORG_TYPE_UPDATE_SUCCESS:
            return {
                ...state,
                vmOrgTypeLoading: false,
                vmOrgTypeData: action.payload?.data?.data,
                error: null,
            };
        case ActionTypes.VM_ORG_TYPE_GET_ERROR:
        case ActionTypes.VM_ORG_TYPE_UPDATE_ERROR:
            return {
                ...state,
                vmOrgTypeLoading: false,
                error: true,
            };

        // VM Multiple Org Configuration
        case ActionTypes.VM_MULTIPLE_ORG_GET_REQUEST:
            return {
                ...state,
                vmMultipleOrgLoading: true,
                vmMultipleOrgData: [],
                error: null,
            };
        case ActionTypes.VM_MULTIPLE_ORG_UPSERT_REQUEST:
        case ActionTypes.VM_MULTIPLE_ORG_DELETE_REQUEST:
            return {
                ...state,
                vmMultipleOrgLoading: true,
                error: null,
            };
        case ActionTypes.VM_MULTIPLE_ORG_GET_SUCCESS:
        case ActionTypes.VM_MULTIPLE_ORG_UPSERT_SUCCESS:
        case ActionTypes.VM_MULTIPLE_ORG_DELETE_SUCCESS:
            return {
                ...state,
                vmMultipleOrgLoading: false,
                vmMultipleOrgData: action.payload?.data?.data,
                error: null,
            };
        case ActionTypes.VM_MULTIPLE_ORG_GET_ERROR:
        case ActionTypes.VM_MULTIPLE_ORG_UPSERT_ERROR:
        case ActionTypes.VM_MULTIPLE_ORG_DELETE_ERROR:
            return {
                ...state,
                vmMultipleOrgLoading: false,
                error: true,
            };

        // VM Pre-Registration
        case ActionTypes.VM_PRE_REGISTRATION_GET_REQUEST:
            return {
                ...state,
                vmPreRegistrationLoading: true,
                vmPreRegistrationData: [],
                error: null,
            };
        case ActionTypes.VM_PRE_REGISTRATION_UPSERT_REQUEST:
        case ActionTypes.VM_PRE_REGISTRATION_DELETE_REQUEST:
            return {
                ...state,
                vmPreRegistrationLoading: true,
                error: null,
            };
        case ActionTypes.VM_PRE_REGISTRATION_GET_SUCCESS:
        case ActionTypes.VM_PRE_REGISTRATION_UPSERT_SUCCESS:
        case ActionTypes.VM_PRE_REGISTRATION_DELETE_SUCCESS:
            return {
                ...state,
                vmPreRegistrationLoading: false,
                vmPreRegistrationData: action.payload?.data?.data,
                error: null,
            };
        case ActionTypes.VM_PRE_REGISTRATION_GET_ERROR:
        case ActionTypes.VM_PRE_REGISTRATION_UPSERT_ERROR:
        case ActionTypes.VM_PRE_REGISTRATION_DELETE_ERROR:
            return {
                ...state,
                vmPreRegistrationLoading: false,
                error: true,
            };
        default:
            return state;
    }
};
